import {TOOL_NAMES} from '../../../constants/tool-names'

export const SLACK_TOOL_TITLES = {
  [TOOL_NAMES.SLACK_POST_MESSAGE]: 'Post a Slack message',
  [TOOL_NAMES.SLACK_REACT]: 'Add a Slack reaction',
  [TOOL_NAMES.SLACK_UNREACT]: 'Remove a Slack reaction',
  [TOOL_NAMES.SLACK_UPLOAD_FILE]: 'Upload a file to Slack',
  [TOOL_NAMES.SLACK_SWITCH_REPO]: 'Switch the thread to a different repo',
  [TOOL_NAMES.SLACK_CREATE_CODE_CHANNEL]: 'Create a Slack code channel',
  [TOOL_NAMES.SLACK_SET_CODE_CHANNEL_CONTEXT]: "Update a code channel's status and context bar",
  [TOOL_NAMES.SLACK_SET_CODE_CHANNEL_DIFF]: "Show a diff in a code channel's diff tab",
  [TOOL_NAMES.SLACK_SET_CODE_CHANNEL_HTML]: 'Show an HTML report in a code channel view tab',
  [TOOL_NAMES.SLACK_ARCHIVE_CODE_CHANNEL]: 'Archive a Slack code channel',
} as const satisfies Record<string, string>
